import { Outlet } from 'react-router-dom';
import PromoHeader from './PromoHeader';
import PromoFooter from './PromoFooter';

/**
 * 프로모(공개) 페이지 레이아웃
 * 원본: layout.pug + header.pug + footer.pug
 */
function PromoLayout() {
  return (
    <>
      <PromoHeader />
      <main>
        <Outlet />
      </main>
      <PromoFooter />
    </>
  );
}

export default PromoLayout;
